import { render, staticRenderFns } from "./inviteJobApplicationQuestionnaire.vue?vue&type=template&id=2b3ca588&scoped=true"
import script from "./inviteJobApplicationQuestionnaire.vue?vue&type=script&lang=js"
export * from "./inviteJobApplicationQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3ca588",
  null
  
)

export default component.exports